import * as amplitude from "@amplitude/analytics-browser";
import GrayModalCloseButton from "@redotech/redo-web/arbiter-icon/gray-close-x.svg";
import { Button, ButtonSize, ButtonTheme } from "@redotech/redo-web/button";
import { CurrencyContext } from "@redotech/redo-web/currency";
import { Flex } from "@redotech/redo-web/flex";
import TagIcon from "@redotech/redo-web/icon-old/tag-settlement-primary.svg";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext, useEffect } from "react";

export const Settlement = memo(function Settlement({
  onCancel,
  onDecline,
  onAccept,
  orderValue,
  settlementRefund,
}: {
  onCancel(): void;
  onDecline(): void;
  onAccept(): void;
  orderValue: Big;
  settlementRefund: number;
}) {
  const { formatCurrency } = useContext(CurrencyContext);

  const upsell = orderValue.mul(settlementRefund);

  useEffect(() => {
    amplitude.logEvent("settlement-available", { upsell: upsell.toString() });
  }, [upsell]);

  return (
    <>
      <Flex align="center" justify="space-between">
        <TagIcon height={52} width={52} />
        <GrayModalCloseButton
          onClick={onCancel}
          style={{ cursor: "pointer" }}
        />
      </Flex>
      <Flex dir="column" gap="4xl">
        <Flex dir="column" gap="xxs">
          <Text fontSize="lg" fontWeight="semibold">
            Special offer
          </Text>
          <Text fontSize="sm" fontWeight="thin" textColor="tertiary">
            If you would rather hang onto your item, we can still offer you{" "}
            {formatCurrency(upsell.toNumber())} back. You skip the hassle of
            shipping it back, and can keep it for yourself or pass it to a
            friend. Win, win.
          </Text>
        </Flex>
        <Flex dir="column" gap="md">
          <Button
            onClick={() => {
              amplitude.logEvent("settlement-accept", { isReviewStep: true });
              onAccept();
            }}
            size={ButtonSize.LARGE}
            theme={ButtonTheme.PRIMARY}
          >
            Keep it, and get {formatCurrency(upsell.toNumber())} instead
          </Button>
          <Button
            onClick={() => {
              amplitude.logEvent("settlement-cancel", { isReviewStep: true });
              onDecline();
            }}
            size={ButtonSize.LARGE}
            theme={ButtonTheme.GHOST}
          >
            No thanks, I want a full refund
          </Button>
        </Flex>
      </Flex>
    </>
  );
});
